module.exports = __webpack_public_path__ + "static/media/Starry-sky.991537c4.jpg";